import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectManualPreLiquidation,
  tryPutManualCliPrecase,
} from "../../../store/slices/backoffice-teachers";
import {
  Typography,
  Grid,
  Button,
  Drawer,
  IconButton,
  TextField,
  FormControl,
  Box,
  Stack,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { useFormik } from "formik";
import ModalMessages from "../../layout/modal-messages";
import Spinner from "../../layout/spinner";
import { NumericFormat } from "react-number-format";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

const validate = (values) => {
  const errors = {};

  if (!values.amount || values.amount === "") errors.amount = "Requerido";

  if (!values.coment || values.coment === "") errors.coment = "Requerido";

  return errors;
};

const NewChargeDrawer = ({
  openDrawer,
  setOpenDrawer,
  setOpenConfirmationDialog,
  dataDrawer,
}) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const manualPreLiquidation = useSelector(selectManualPreLiquidation);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      batchprocessid: dataDrawer.batchprocessid,
      cliPrecaseId: dataDrawer.cliPrecaseId,
      amount: "",
      coment: "",
    },
    validate,
    onSubmit: async (values) => {
      const action = await dispatch(tryPutManualCliPrecase(values));
      if (action.payload.data.isValid) {
        setOpenConfirmationDialog(true);
        setOpenDrawer(false);
      }
    },
  });

  return (
    <Drawer
      anchor={isMobile ? "bottom" : "right"}
      open={openDrawer}
      PaperProps={{
        sx: {
          zIndex: 1203,
          width: { xs: "100vw", sm: 500 },
          maxWidth: "100%",
          maxHeight: { xs: "90vh", sm: "100%" },
          borderRadius: { xs: "12px 12px 0 0", sm: 0 },
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
        },
      }}
      onClose={() => setOpenDrawer(false)}
      sx={{
        zIndex: 1203,
        flexShrink: 0,
      }}
    >
      <Box
        sx={{
          flexShrink: 0,
          bgcolor: "#194B6F",
          color: "white",
          position: "relative",
          px: { xs: 2, sm: 3 },
          pt: { xs: 2, sm: 4 },
          pb: { xs: 1.5, sm: 3 },
        }}
      >
        <IconButton
          sx={{
            position: "absolute",
            top: { xs: 8, sm: 16 },
            right: { xs: 8, sm: 16 },
            color: "white",
          }}
          onClick={() => setOpenDrawer(false)}
        >
          <Close />
        </IconButton>

        <Typography
          align="left"
          sx={{
            fontWeight: 700,
            fontSize: 18,
            mb: { xs: 0, sm: 1 },
            pr: 4,
          }}
        >
          Nuevo Gasto
        </Typography>

        <Typography
          variant="body2"
          align="left"
          sx={{ display: { xs: "none", sm: "block" } }}
        >
          Por favor, complete información en cada campo que se solicite en el
          formulario
        </Typography>
      </Box>

      <Box
        sx={{
          flex: 1,
          overflowY: "auto",
          backgroundColor: "white",
          p: { xs: 2, sm: 3 },
        }}
      >
        <Grid container rowSpacing={3} spacing={{ xs: 2, sm: 3 }}>
          <Grid item xs={12}>
            <Typography
              sx={{ fontWeight: "bold", fontSize: "1.2rem" }}
              align="left"
              color="text.primary"
            >
              Prof. {dataDrawer.teacher}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <NumericFormat
                variant="outlined"
                label="Monto del pago"
                size="small"
                name="amount"
                thousandSeparator="."
                decimalSeparator=","
                isNumericString
                allowNegative={true}
                decimalScale={2}
                fixedDecimalScale
                prefix="$"
                InputLabelProps={{ shrink: true }}
                customInput={TextField}
                value={formik.values.amount}
                onValueChange={(values) => {
                  const { floatValue } = values;
                  formik.setFieldValue("amount", floatValue);
                }}
                error={formik.touched.amount && Boolean(formik.errors.amount)}
                helperText={formik.touched.amount && formik.errors.amount}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} whiteSpace="normal">
            <TextField
              id="coment"
              label="Comentarios"
              multiline
              rows={5}
              fullWidth
              onChange={formik.handleChange}
              value={formik.values.coment}
              error={formik.touched.coment && Boolean(formik.errors.coment)}
              helperText={formik.touched.coment && formik.errors.coment}
            />
          </Grid>

          <Grid item xs={12} sx={{ textAlign: "center" }}>
            {isMobile ? (
              <Stack direction="column" spacing={2} sx={{ mt: 1, mb: 2 }}>
                <Button
                  fullWidth
                  variant="contained"
                  onClick={formik.handleSubmit}
                  disabled={manualPreLiquidation.isLoading}
                >
                  {manualPreLiquidation?.isLoading && <Spinner color="primary" />}
                  Generar
                </Button>
                <Button
                  fullWidth
                  variant="outlined"
                  color="error"
                  disabled={manualPreLiquidation.isLoading}
                  onClick={() => setOpenDrawer(false)}
                >
                  Cancelar
                </Button>
              </Stack>
            ) : (
              <Box sx={{ mt: 2, mb: 2, display: "inline-block" }}>
                <Button
                  variant="contained"
                  onClick={formik.handleSubmit}
                  disabled={manualPreLiquidation.isLoading}
                  sx={{ width: 100, marginRight: 2 }}
                >
                  {manualPreLiquidation?.isLoading && <Spinner color="primary" />}
                  Generar
                </Button>
                <Button
                  variant="outlined"
                  color="error"
                  disabled={manualPreLiquidation.isLoading}
                  sx={{ border: 2, width: 100 }}
                  onClick={() => setOpenDrawer(false)}
                >
                  Cancelar
                </Button>
              </Box>
            )}
          </Grid>
        </Grid>
      </Box>
      {manualPreLiquidation.errors &&
        manualPreLiquidation.errors.length > 0 && (
          <ModalMessages errors={manualPreLiquidation.errors} />
        )}
    </Drawer>
  );
};

export default NewChargeDrawer; 